import { createFileRoute } from "@tanstack/react-router";
import z from "zod";
import { FormBuilderPanel } from "@/features/form-editor/components/form-builder/form-builder-panel";

export const Route = createFileRoute(
	"/_authenticated/(org-app)/_orgAdmin/org-admin/$orgId/configuration/ticketTypes/$ticketTypeId/full/form/",
)({
	component: OrgTicketTypeFullFormBuilderRoute,
	params: {
		parse: (raw) => {
			const p = raw as { orgId: string; ticketTypeId: string };
			return {
				orgId: z.string().parse(p.orgId),
				ticketTypeId: z.string().parse(p.ticketTypeId),
			};
		},
	},
});

function OrgTicketTypeFullFormBuilderRoute() {
	return (
		<div className="flex min-h-[min(70vh,720px)] min-h-0 flex-1 flex-col px-4">
			<FormBuilderPanel />
		</div>
	);
}
